import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core'
import { MatPaginator } from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'

import { LaskunAsiakas } from '@lemon/core-firebase/model/lasku'

import { AsiakasDialogiService } from './asiakas-dialogi.service'
import { AsiakkaatFirestoreDataSource } from './asiakkaat.firestore.datasource'

import { Observable, combineLatest } from 'rxjs'
import { map } from 'rxjs/operators'

interface NaytettavaAsiakas extends LaskunAsiakas {
  toimitusteksti: string
}

export type AsiakasProperties = 'nimi' | 'ytunnus' | 'postitoimipaikka' | 'myynninLaji' | 'toimitus' | 'maksuehto' | undefined

@Component({
  selector: 'app-asiakkaat',
  templateUrl: './asiakkaat.component.html',
  styleUrls: ['./asiakkaat.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AsiakkaatComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) _paginator: MatPaginator
  @ViewChild(MatSort, { static: true }) _sort: MatSort

  dataSource: AsiakkaatFirestoreDataSource | null
  propertiesToDisplay: AsiakasProperties[] = ['nimi', 'ytunnus', 'postitoimipaikka', 'myynninLaji', 'toimitus', 'maksuehto']
  hakuAvoinna = false

  naytaEiYhtaanObservable: Observable<boolean>
  naytettavatAsiakkaatObservable: Observable<NaytettavaAsiakas[]>
  lataaObservable: Observable<boolean>

  constructor(
    private _dataSource: AsiakkaatFirestoreDataSource,
    private _asiakasDialogiService: AsiakasDialogiService,
  ) {
    this.dataSource = _dataSource
    this.lataaObservable = this._dataSource.lataaObservable
    this.naytettavatAsiakkaatObservable = this._dataSource.asiakkaatObservable.pipe(
      map(asiakkaat => asiakkaat.map(asiakas => ({ ...asiakas, toimitusteksti: this._asiakasDialogiService.annaToimitusteksti(asiakas) }))),
    )
    this.naytaEiYhtaanObservable = combineLatest([this._dataSource.rivienMaaraObservable, this._dataSource.lataaObservable]).pipe(
      map(([rivienMaara, lataa]) => {
        if (lataa) {
          return false
        }
        return rivienMaara < 1
      }),
    )
  }

  ngOnInit() {
    const currentSort = this._dataSource.getSort()
    this._sort.sort({
      id: currentSort.active,
      disableClear: true,
      start: currentSort.direction === 'asc' ? 'asc' : 'desc',
    })
    this._sort.sortChange.subscribe(sort => {
      this._dataSource.changeSort(sort)
    })

    this._paginator.page.subscribe(page => {
      this._dataSource.changePage(page)
    })
  }

  avaaHaku() {
    this.hakuAvoinna = true
  }

  suljeHaku() {
    this.hakuAvoinna = false
  }

  muokkaa(asiakas: LaskunAsiakas) {
    this._asiakasDialogiService.avaaAsiakasrekisterinAsiakas(asiakas)
  }

  lisaa() {
    this._asiakasDialogiService.avaaAsiakasrekisterinAsiakas(null)
  }
}
